import { createAsyncThunk } from '@reduxjs/toolkit';

import ooeConstants from '../constants';
import type { State } from '../reducers';
import { ValidatedDeliveryAddress } from '../order/schemas';
import { getAutoCompleteResults, validateAddressFromProtobuf } from './apis';
import { AddressResult } from './schemas';
import { selectAddressSearchValue } from './selectors';

export const autocompleteAddress = createAsyncThunk(
  'eventDetails/autocompleteAddress',
  async (_arg: void, { getState, signal }): Promise<{ results: AddressResult[] }> => {
    const state = getState() as State;
    const query = selectAddressSearchValue(state).trim();
    if (query.length < ooeConstants.ADDRESS_SEARCH_MIN_TYPEAHEAD_LENGTH) {
      return { results: [] };
    }

    const results = await getAutoCompleteResults(query, signal);
    if (signal.aborted) {
      throw signal.reason instanceof Error ? signal.reason : new DOMException('Aborted', 'AbortError');
    }

    return { results: results.slice(0, ooeConstants.ADDRESS_SEARCH_MAX_RESULTS) };
  },
);

export const validateAddress = createAsyncThunk(
  'eventDetails/validateAddress',
  async (
    autocompleteResult: AddressResult,
    { signal },
  ): Promise<{ autocompleteResult: AddressResult; validated: ValidatedDeliveryAddress }> => {
    const validated = await validateAddressFromProtobuf(autocompleteResult, signal);
    if (signal.aborted) {
      throw signal.reason instanceof Error ? signal.reason : new DOMException('Aborted', 'AbortError');
    }

    return { autocompleteResult, validated };
  },
);
